<template lang="pug">
div
  v-text-field(
    v-for="(answer, key) in answer_values",
    :key="key",
    outlined,
    :label="answer.label",
    hide-details,
    v-model="input"
  )
</template>

<script>
export default {
  name: "Input",

  props: ["answer_values", "value"],

  computed: {
    input: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>